<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">{{ !loading ? (isEditMode ? "Edit" : "Create") : "" }} Step</div>
    </div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/ptpstep">Back to PTP Workflow Steps</a>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-body">
                <form nz-form [formGroup]="form" class="form-horizontal">
                    <div class="form-group">
                        <label for="stepName" class="col-md-2 control-label">
                            Name<span style="color: red"> *</span>
                        </label>
                        <div class="col-md-6">
                            <input
                                id="stepName"
                                type="text"
                                maxlength="200"
                                class="form-control"
                                formControlName="stepName" />
                            @if (form.get("stepName")?.touched && form.get("stepName")?.invalid) {
                                <span class="text-danger"> Name is required </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="stepType" class="col-md-2 control-label">Step Type</label>
                        <div class="col-md-6">
                            <nz-select id="stepType" style="width: 100%" formControlName="stepType">
                                @for (option of stepTypeOptions; track option.value) {
                                    <nz-option [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                                }
                            </nz-select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="order" class="col-md-2 control-label">Order</label>
                        <div class="col-md-6">
                            <input id="order" type="number" min="0" class="form-control" formControlName="order" />
                            @if (form.get("order")?.touched && form.get("order")?.invalid) {
                                <span class="text-danger"> Order must be a non-negative number </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="dollarAmount" class="col-md-2 control-label">Dollar Amount</label>
                        <div class="col-md-6">
                            <input
                                id="dollarAmount"
                                type="number"
                                step="0.01"
                                class="form-control"
                                formControlName="dollarAmount" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="showCreate" class="col-md-2 control-label">Show Create?</label>
                        <div class="col-md-6">
                            <label nz-checkbox id="showCreate" formControlName="showCreate"></label>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <button nz-button nzType="primary" (click)="save()">Save Changes</button>
    </div>
</div>
